import React, { useEffect, useState, useRef } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, Coins, Shield, Leaf, FileText, Settings, Zap, ChevronDown, ChevronRight, User, LogOut, Bell, LayoutList, Wrench, Users, BookOpen, ScrollText, MessageSquare, Radio, Sliders, Check, CreditCard, PanelLeft, PanelLeftClose, MousePointerClick, Menu, X, AlertCircle, Network } from 'lucide-react';
const SERVICES = [{
  id: 's1',
  name: 'Customer Assistant',
  health: 'healthy' as const
}, {
  id: 's2',
  name: 'Smart Matcher',
  health: 'healthy' as const
}, {
  id: 's3',
  name: 'Content Moderator',
  health: 'warning' as const
}, {
  id: 's4',
  name: 'AI Tutor',
  health: 'healthy' as const
}];
function UserMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={menuRef} data-id="element-493">
      <button onClick={() => setOpen(!open)} className="flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-white/[0.06] transition-all" data-id="element-494">
        <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face" alt="Marco Rossi" className="w-7 h-7 rounded-full object-cover border border-white/[0.12]" data-id="element-495" />
        <div className="hidden md:flex flex-col items-start" data-id="element-496">
          <span className="text-[13px] font-medium text-white/80 leading-tight" data-id="element-497">
            Marco Rossi
          </span>
          <span className="text-[10px] text-white/35 leading-tight" data-id="element-498">Admin</span>
        </div>
        <ChevronDown className={`w-3.5 h-3.5 text-white/30 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-499" />
      </button>

      {open && <div className="absolute top-full mt-2 right-0 w-[200px] bg-[#141414] border border-white/[0.08] rounded-xl overflow-hidden shadow-xl z-50" data-id="element-500">
          <div className="px-4 py-3 border-b border-white/[0.06]" data-id="element-501">
            <p className="text-[13px] font-medium text-white" data-id="element-502">Marco Rossi</p>
            <p className="text-[11px] text-white/40 mt-0.5" data-id="element-503">
              marco.rossi@dmood.ai
            </p>
          </div>
          <div className="py-1" data-id="element-504">
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-white/60 hover:text-white hover:bg-white/[0.06] transition-all" data-id="element-505">
              <User className="w-4 h-4" data-id="element-506" />
              Il mio profilo
            </button>
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-white/60 hover:text-white hover:bg-white/[0.06] transition-all" data-id="element-507">
              <Settings className="w-4 h-4" data-id="element-508" />
              Impostazioni
            </button>
          </div>
          <div className="border-t border-white/[0.10] py-1" data-id="element-509">
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-red-400/80 hover:text-red-400 hover:bg-red-500/[0.06] transition-all" data-id="element-510">
              <LogOut className="w-4 h-4" data-id="element-511" />
              Esci
            </button>
          </div>
        </div>}
    </div>;
}
function ServiceSelector({
  selectedId,
  onSelect
}: {
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const selected = SERVICES.find(s => s.id === selectedId);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const healthDot = (health: string) => health === 'healthy' ? 'bg-[#8eff01]' : health === 'warning' ? 'bg-amber-500' : 'bg-red-500';
  return <div className="relative mb-2" ref={ref} data-id="element-512">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2.5 px-3 py-2.5 bg-white/[0.04] border border-white/[0.10] rounded-lg hover:border-white/[0.18] transition-all" data-id="element-513">
        <div className={`w-2 h-2 rounded-full ${healthDot(selected?.health || 'healthy')} flex-shrink-0`} data-id="element-514" />
        <span className="text-[13px] font-medium text-white/80 truncate flex-1 text-left" data-id="element-515">
          {selected?.name || 'Seleziona servizio'}
        </span>
        <ChevronDown className={`w-3.5 h-3.5 text-white/30 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-516" />
      </button>

      {open && <div className="absolute top-full mt-1.5 left-0 right-0 bg-[#141414] border border-white/[0.08] rounded-xl overflow-hidden shadow-xl z-50" data-id="element-517">
          {SERVICES.map(service => <button key={service.id} onClick={() => {
        onSelect(service.id);
        setOpen(false);
      }} className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-left transition-all ${service.id === selectedId ? 'bg-white/[0.08] text-white' : 'text-white/55 hover:bg-white/[0.05] hover:text-white/80'}`} data-id="element-518">
              <div className={`w-2 h-2 rounded-full ${healthDot(service.health)} flex-shrink-0`} data-id="element-519" />
              <span className="text-[13px] font-medium truncate flex-1" data-id="element-520">
                {service.name}
              </span>
              {service.id === selectedId && <Check className="w-3.5 h-3.5 text-[#8eff01] flex-shrink-0" data-id="element-521" />}
            </button>)}
        </div>}
    </div>;
}
export function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCanvasPage = false;
  const [sidebarMode, setSidebarMode] = useState<'global' | 'service'>('global');
  const [selectedServiceId, setSelectedServiceId] = useState('s1');
  const [sidebarState, setSidebarState] = useState<'open' | 'closed' | 'hover'>('open');
  const [isHovering, setIsHovering] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [complianceSubmenuOpen, setComplianceSubmenuOpen] = useState(false);
  const effectivelyOpen = sidebarState === 'open' || sidebarState === 'hover' && isHovering;
  const sidebarWidth = effectivelyOpen ? 220 : 64;
  // Auto-open compliance submenu if on a compliance route
  useEffect(() => {
    if (location.pathname.startsWith('/compliance')) {
      setComplianceSubmenuOpen(true);
    }
  }, [location.pathname]);
  const cycleSidebarState = () => {
    setSidebarState(prev => {
      if (prev === 'open') return 'closed';
      if (prev === 'closed') return 'hover';
      return 'open';
    });
    setIsHovering(false);
  };
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  // Auto-switch to service mode
  useEffect(() => {
    const match = location.pathname.match(/^\/servizio\/(\w+)/);
    if (match) {
      setSidebarMode('service');
      setSelectedServiceId(match[1]);
    }
  }, [location.pathname]);
  const handleServiceSelect = (id: string) => {
    setSelectedServiceId(id);
    navigate(`/servizio/${id}`);
  };
  return <div className="flex min-h-screen bg-[#121212]" data-id="element-522">
      {/* Mobile backdrop */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-black/60 z-30 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-523" />}

      {/* Sidebar */}
      <aside className={`fixed left-0 top-0 bottom-0 bg-[#121212] border-r border-white/[0.12] flex flex-col transition-all duration-300 ease-in-out
          ${isMobileMenuOpen ? 'translate-x-0 z-40' : '-translate-x-full lg:translate-x-0 z-40'}
        `} style={{
      width: isMobileMenuOpen ? '280px' : `${sidebarWidth}px`
    }} onMouseEnter={() => {
      if (sidebarState === 'hover' && window.innerWidth >= 1024) setIsHovering(true);
    }} onMouseLeave={() => {
      if (sidebarState === 'hover' && window.innerWidth >= 1024) setIsHovering(false);
    }} data-id="element-524">
        {/* Logo */}
        <div className="h-14 px-5 border-b border-white/[0.12] flex items-center justify-between overflow-hidden" data-id="element-525">
          {effectivelyOpen || isMobileMenuOpen ? <img src="https://cdn.magicpatterns.com/uploads/uhyeQQiHgiWSZPJyHQkyvX/Logo_Dmood_white.svg" alt="Dmood" className="w-auto flex-shrink-0" style={{
          height: '14px'
        }} data-id="element-526" /> : <img src="https://cdn.magicpatterns.com/uploads/5VoBhcRLCVpjzxVyQmBRWG/Logo_v1_small.svg" alt="Dmood" className="w-6 h-6 flex-shrink-0 brightness-0 invert mx-auto" data-id="element-527" />}
          <button onClick={() => setIsMobileMenuOpen(false)} className="lg:hidden p-2 text-white/40 hover:text-white/70 hover:bg-white/[0.04] rounded-lg transition-all" data-id="element-528">
            <X className="w-5 h-5" data-id="element-529" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-3 space-y-1 overflow-y-auto overflow-x-hidden custom-scrollbar transition-all duration-300 ease-in-out" style={{
        paddingLeft: effectivelyOpen || isMobileMenuOpen ? 16 : 8,
        paddingRight: effectivelyOpen || isMobileMenuOpen ? 16 : 8
      }} data-id="element-530">
          {sidebarMode === 'global' ? <>
              <NavLink to="/costs" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Overview" data-id="element-531">
                <Home className="w-4 h-4 flex-shrink-0" data-id="element-532" />
                <span data-id="element-533">Overview</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-534">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[10px] font-medium text-white/25 uppercase tracking-wider whitespace-nowrap" data-id="element-535">
                    Governance
                  </p> : <div className="h-px bg-white/[0.10] w-full mx-1" data-id="element-536" />}
              </div>

              {/* Compliance with Submenu */}
              <div data-id="element-537">
                <button onClick={() => {
              if (effectivelyOpen || isMobileMenuOpen) {
                setComplianceSubmenuOpen(!complianceSubmenuOpen);
              } else {
                navigate('/compliance/ai-act');
              }
            }} className={`nav-item w-full${location.pathname.startsWith('/compliance') ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Compliance" data-id="element-538">
                  <Shield className={`w-4 h-4 flex-shrink-0 ${location.pathname.startsWith('/compliance') ? 'text-[#8eff01]' : ''}`} data-id="element-539" />
                  <span className="flex-1 text-left" data-id="element-540">Compliance</span>
                  {(effectivelyOpen || isMobileMenuOpen) && <ChevronRight className={`w-3.5 h-3.5 transition-transform duration-200 ${complianceSubmenuOpen ? 'rotate-90' : ''} ${location.pathname.startsWith('/compliance') ? 'text-white/60' : 'text-white/30'}`} data-id="element-541" />}
                </button>

                {/* Submenu */}
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${complianceSubmenuOpen && (effectivelyOpen || isMobileMenuOpen) ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-542">
                  <div className="ml-4 mt-1 space-y-1 border-l border-white/[0.10] pl-3" data-id="element-543">
                    <NavLink to="/compliance/ai-act" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[12px] font-medium rounded-lg transition-all ${isActive ? 'text-white bg-white/[0.06]' : 'text-white/40 hover:text-white/70 hover:bg-white/[0.04]'}`} data-id="element-544">
                      {({
                    isActive
                  }) => <>
                          <AlertCircle className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#8eff01]' : ''}`} data-id="element-545" />
                          <span data-id="element-546">AI Act</span>
                        </>}
                    </NavLink>
                    <NavLink to="/compliance/gdpr" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[12px] font-medium rounded-lg transition-all ${isActive ? 'text-white bg-white/[0.06]' : 'text-white/40 hover:text-white/70 hover:bg-white/[0.04]'}`} data-id="element-547">
                      {({
                    isActive
                  }) => <>
                          <Shield className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#8eff01]' : ''}`} data-id="element-548" />
                          <span data-id="element-549">GDPR</span>
                        </>}
                    </NavLink>
                    <NavLink to="/compliance/audit" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[12px] font-medium rounded-lg transition-all ${isActive ? 'text-white bg-white/[0.06]' : 'text-white/40 hover:text-white/70 hover:bg-white/[0.04]'}`} data-id="element-550">
                      {({
                    isActive
                  }) => <>
                          <FileText className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#8eff01]' : ''}`} data-id="element-551" />
                          <span data-id="element-552">Audit Trail</span>
                        </>}
                    </NavLink>
                  </div>
                </div>
              </div>

              <NavLink to="/greenops" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="GreenOps" data-id="element-553">
                <Leaf className="w-4 h-4 flex-shrink-0" data-id="element-554" />
                <span data-id="element-555">GreenOps</span>
              </NavLink>

              <NavLink to="/canvas" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="AI Map" data-id="element-556">
                <Network className="w-4 h-4 flex-shrink-0" data-id="element-557" />
                <span data-id="element-558">AI Map</span>
              </NavLink>

              <NavLink to="/reports" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Report" data-id="element-559">
                <FileText className="w-4 h-4 flex-shrink-0" data-id="element-560" />
                <span data-id="element-561">Report</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-562">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[10px] font-medium text-white/25 uppercase tracking-wider whitespace-nowrap" data-id="element-563">
                    Configurazione
                  </p> : <div className="h-px bg-white/[0.10] w-full mx-1" data-id="element-564" />}
              </div>

              <NavLink to="/providers" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Provider" data-id="element-565">
                <Zap className="w-4 h-4 flex-shrink-0" data-id="element-566" />
                <span data-id="element-567">Provider</span>
              </NavLink>
              <NavLink to="/tools" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Tool" data-id="element-568">
                <Wrench className="w-4 h-4 flex-shrink-0" data-id="element-569" />
                <span data-id="element-570">Tool</span>
              </NavLink>
              <NavLink to="/users" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Fornitori & utenti" data-id="element-571">
                <Users className="w-4 h-4 flex-shrink-0" data-id="element-572" />
                <span data-id="element-573">Fornitori & utenti</span>
              </NavLink>
            </> : <>
              {(effectivelyOpen || isMobileMenuOpen) && <ServiceSelector selectedId={selectedServiceId} onSelect={handleServiceSelect} data-id="element-574" />}

              <div className="h-8 flex items-center overflow-hidden" data-id="element-575">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[10px] font-medium text-white/25 uppercase tracking-wider whitespace-nowrap" data-id="element-576">
                    Servizio
                  </p> : <div className="h-px bg-white/[0.10] w-full mx-1" data-id="element-577" />}
              </div>

              <NavLink to={`/servizio/${selectedServiceId}`} end className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Overview" data-id="element-578">
                <LayoutList className="w-4 h-4 flex-shrink-0" data-id="element-579" />
                <span data-id="element-580">Overview</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/config`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Configurazione" data-id="element-581">
                <Sliders className="w-4 h-4 flex-shrink-0" data-id="element-582" />
                <span data-id="element-583">Configurazione</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/canali`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Canali" data-id="element-584">
                <Radio className="w-4 h-4 flex-shrink-0" data-id="element-585" />
                <span data-id="element-586">Canali</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/knowledge`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Knowledge" data-id="element-587">
                <BookOpen className="w-4 h-4 flex-shrink-0" data-id="element-588" />
                <span data-id="element-589">Knowledge</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/strumenti`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Strumenti" data-id="element-590">
                <Wrench className="w-4 h-4 flex-shrink-0" data-id="element-591" />
                <span data-id="element-592">Strumenti</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/istruzioni`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Istruzioni" data-id="element-593">
                <MessageSquare className="w-4 h-4 flex-shrink-0" data-id="element-594" />
                <span data-id="element-595">Istruzioni</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-596">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[10px] font-medium text-white/25 uppercase tracking-wider whitespace-nowrap" data-id="element-597">
                    Analisi
                  </p> : <div className="h-px bg-white/[0.10] w-full mx-1" data-id="element-598" />}
              </div>

              <NavLink to={`/servizio/${selectedServiceId}/log`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Log" data-id="element-599">
                <ScrollText className="w-4 h-4 flex-shrink-0" data-id="element-600" />
                <span data-id="element-601">Log</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/costi`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Costi" data-id="element-602">
                <CreditCard className="w-4 h-4 flex-shrink-0" data-id="element-603" />
                <span data-id="element-604">Costi</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/compliance`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Compliance" data-id="element-605">
                <Shield className="w-4 h-4 flex-shrink-0" data-id="element-606" />
                <span data-id="element-607">Compliance</span>
              </NavLink>
            </>}
        </nav>

        {/* Bottom toggle (desktop only) */}
        <div className="hidden lg:block p-3 border-t border-white/[0.12]" data-id="element-608">
          <button onClick={cycleSidebarState} className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg hover:bg-white/[0.06] transition-all group" title={sidebarState === 'open' ? 'Chiudi sidebar' : sidebarState === 'closed' ? 'Sidebar su hover' : 'Apri sidebar'} data-id="element-609">
            <div className="flex-shrink-0" data-id="element-610">
              {sidebarState === 'open' && <PanelLeft className="w-4 h-4 text-white/45 group-hover:text-white/70" data-id="element-611" />}
              {sidebarState === 'closed' && <PanelLeftClose className="w-4 h-4 text-white/45 group-hover:text-white/70" data-id="element-612" />}
              {sidebarState === 'hover' && <MousePointerClick className="w-4 h-4 text-white/45 group-hover:text-white/70" data-id="element-613" />}
            </div>
            <div className="flex items-center gap-2 flex-1 min-w-0 overflow-hidden whitespace-nowrap" data-id="element-614">
              <span className="text-[12px] text-white/45 group-hover:text-white/70 truncate" data-id="element-615">
                {sidebarState === 'open' ? 'Aperta' : sidebarState === 'closed' ? 'Chiusa' : 'Hover'}
              </span>
              <div className="flex items-center gap-1 ml-auto flex-shrink-0" data-id="element-616">
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'open' ? 'bg-[#8eff01]' : 'bg-white/[0.12]'}`} data-id="element-617" />
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'closed' ? 'bg-[#8eff01]' : 'bg-white/[0.12]'}`} data-id="element-618" />
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'hover' ? 'bg-[#8eff01]' : 'bg-white/[0.12]'}`} data-id="element-619" />
              </div>
            </div>
          </button>
        </div>
      </aside>

      {/* Top Bar */}
      {!isCanvasPage && <header className="fixed top-0 right-0 h-14 bg-[#121212]/95 backdrop-blur-md border-b border-white/[0.12] z-30 flex items-center justify-between px-4 lg:px-6 transition-all duration-300 ease-in-out" style={{
      left: window.innerWidth >= 1024 ? `${sidebarWidth}px` : '0'
    }} data-id="element-620">
          <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden p-2 text-white/40 hover:text-white/70 hover:bg-white/[0.06] rounded-lg transition-all" data-id="element-621">
            <Menu className="w-5 h-5" data-id="element-622" />
          </button>

          <div className="hidden lg:block" data-id="element-623" />

          <div className="flex items-center gap-3" data-id="element-624">
            <button className="w-8 h-8 flex items-center justify-center rounded-lg text-white/35 hover:text-white/60 hover:bg-white/[0.06] transition-all relative" data-id="element-625">
              <Bell className="w-4 h-4" data-id="element-626" />
              <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-[#FE0127]" data-id="element-627" />
            </button>
            <div className="w-px h-6 bg-white/[0.08]" data-id="element-628" />
            <UserMenu data-id="element-629" />
          </div>
        </header>}

      {/* Main Content */}
      <main className={`flex-1 min-h-screen transition-all duration-300 ease-in-out ${!isCanvasPage ? 'pt-14' : ''}`} style={{
      marginLeft: window.innerWidth >= 1024 ? `${sidebarWidth}px` : '0'
    }} data-id="element-630">
        <Outlet data-id="element-631" />
      </main>
    </div>;
}